import React, { useEffect, useState } from 'react';
import { BookOpen, School, Users, Shield, Film, Newspaper } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../../api/client';

export default function DashboardPage() {
  const { user, can } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ tutorials:0, schools:0, users:0, roles:0, creatorVideos:0, blogVideos:0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const results = await Promise.allSettled([
          can('tutorials','view')      ? api.get('/tutorials') : null,
          can('users','view')          ? api.get('/users') : null,
          can('roles','view')          ? api.get('/roles') : null,
          can('creator_videos','view') ? api.get('/creator-videos') : null,
          can('blog_videos','view')    ? api.get('/blog-videos') : null,
        ]);
        setStats({
          tutorials:     results[0].value?.data?.data?.length ?? 0,
          users:         results[1].value?.data?.data?.length ?? 0,
          roles:         results[2].value?.data?.data?.length ?? 0,
          creatorVideos: results[3].value?.data?.data?.length ?? 0,
          blogVideos:    results[4].value?.data?.data?.length ?? 0,
        });
      } catch {}
    };
    fetchStats();
  }, [can]);

  const greet = () => { const h = new Date().getHours(); return h<12?'Good morning':h<17?'Good afternoon':'Good evening'; };

  const QuickCard = ({ icon, label, value, color, to, perm }) => {
    if (perm && !can(perm[0],perm[1])) return null;
    return (
      <div className="stat-card" style={{ cursor: to ? 'pointer' : 'default' }} onClick={() => to && navigate(to)}>
        <div className={`stat-icon ${color}`}>{icon}</div>
        <div><div className="stat-value">{value}</div><div className="stat-label">{label}</div></div>
      </div>
    );
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">{greet()}, {user?.fullName?.split(' ')[0]} 👋</h1>
          <p className="page-subtitle">Here's your Swardhara portal overview</p>
        </div>
      </div>

      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(200px,1fr))' }}>
        <QuickCard icon={<BookOpen size={22}/>} label="Tutorial Volumes" value={stats.tutorials} color="orange" to="/tutorials" perm={['tutorials','view']} />
        <QuickCard icon={<Film size={22}/>} label="Creator Videos" value={stats.creatorVideos} color="blue" to="/creator-videos" perm={['creator_videos','view']} />
        <QuickCard icon={<Newspaper size={22}/>} label="Blog Videos" value={stats.blogVideos} color="green" to="/blog-videos" perm={['blog_videos','view']} />
        <QuickCard icon={<Users size={22}/>} label="Admin Users" value={stats.users} color="red" to="/users" perm={['users','view']} />
        <QuickCard icon={<Shield size={22}/>} label="Roles Defined" value={stats.roles} color="orange" to="/roles" perm={['roles','view']} />
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Your Permissions</span>
          <span className="badge badge-orange">{user?.roleDisplayName}</span>
        </div>
        <div className="card-body">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(170px,1fr))', gap:12 }}>
            {user?.permissions && Object.entries(user.permissions).map(([module, perms]) => {
              const actions = Object.entries(perms).filter(([,v])=>v).map(([k])=>k);
              if (!actions.length) return null;
              return (
                <div key={module} style={{ background:'var(--orange-50)', border:'1px solid var(--orange-100)', borderRadius:'var(--radius-sm)', padding:'12px 14px' }}>
                  <div style={{ fontSize:12, fontWeight:600, color:'var(--orange-600)', textTransform:'capitalize', marginBottom:6 }}>{module.replace(/_/g,' ')}</div>
                  <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                    {actions.map(a => <span key={a} className="badge badge-green" style={{fontSize:10}}>{a}</span>)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
